import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import * as api from '../../data/api';
import { closeSheet } from '../../state/sheets';

/** Em quais processos esta rotina aparece (desenhador de processos). */
export function RoutineProcesses({ routineId }: { routineId: string }) {
  const nav = useNavigate();
  const q = useQuery({ queryKey: ['processes', 'routine', routineId], queryFn: () => api.fetchProcessesByRoutine(routineId) });
  if (!q.data?.length) return null;
  return (
    <p className="muted rt-procs">Aparece {q.data.length === 1 ? 'no processo' : 'nos processos'}{' '}
      {q.data.map((p, i) => (
        <span key={p.id}>{i ? ', ' : ''}<button type="button" className="side-link inline" onClick={() => { closeSheet(); nav(`/processos/${p.id}`); }}>{p.name}</button></span>
      ))}
    </p>
  );
}
